export default __webpack_public_path__ + "static/media/megaDisk.e4651a18.webp";